import { Button, Col, Divider, Flex, Form, Input, Row, Steps, Typography, message, notification } from 'antd'
import React, { useEffect, useState } from 'react'
import {
    UserOutlined,
    HomeOutlined
} from '@ant-design/icons';
import { BUTTON, TEXT } from '../../../layout/style';
import CompanyRegistration from './CompanyRegistration';
import UserRegistration from './UserRegistration';
import { useDispatch } from 'react-redux';
import { companyRegisterStart, companyRegisterSuccess, companyRegisterFailure } from '../../../redux/slices/companySlice';
import AuthRestAPI from '../../../restAPI/AuthRestAPI';
import validateForm from '../../../utils/FormValidation';
import validationRules from '../../../assets/validation/rules';
import { Link, useNavigate } from 'react-router-dom';
import { AESEncryption } from '../../../utils/Aes'

const { Text, Title } = Typography;


export default function SignUp() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [api, contextHolder] = notification.useNotification();
    const [companyFormData, setCompanyFormData] = useState({})
    const [userFormData, setUserFormData] = useState({})
    const [current, setCurrent] = useState(0);
    const [errors, setErrors] = useState({});
    const [currentValidation, setCurrentValidation] = useState('');
    const [hasNotificationShown, setHasNotificationShown] = useState(false);

    const openNotificationWithIcon = (type, message, description, placement) => {
        api[type]({
            message: message,
            description: description,
            placement
        });
    };

    const handleCompanyFormSubmit = (formData) => {
        setCompanyFormData(formData);
    }
    const handleUserFormSubmit = (formData) => {
        setUserFormData(formData);
    }

    const steps = [
        {
            title: 'First',
            content: <CompanyRegistration onSubmit={handleCompanyFormSubmit} sendErrors={errors} />,
        },
        {
            title: 'Second',
            content: <UserRegistration onSubmit={handleUserFormSubmit} sendErrors={errors} />,
        },
    ];

    // validate  form values
    const handleFormValueValidation = (obj) => {
        if (obj) {
            for (const key in obj) {
                if (obj.hasOwnProperty(key) && !obj[key]) {
                    openNotificationWithIcon('error', 'Please fill all the fields.', '', 'bottomLeft')
                    return false;
                }
            }
            return true;
        }
    }

    const next = () => {
        const validationResult = validateForm(companyFormData, validationRules)
        const firstErrorMessage = Object.values(validationResult.errors)[0];

        if (!validationResult.isValid) {
            const err = validationResult.errors
            const newErrors = {};
            Object.keys(err).forEach((value) => {
                newErrors[value] = err[value];
            })
            setErrors(newErrors);
            setCurrentValidation(firstErrorMessage);

            if (!hasNotificationShown || currentValidation !== firstErrorMessage) {
                openNotificationWithIcon('error', "Validation", Object.values(err)[0], 'topRight');
                setHasNotificationShown(true);
            }

        } else {
            setHasNotificationShown(false)
            dispatch(companyRegisterStart());
            const payload = {
                name: companyFormData.companyName,
                address: companyFormData.companyAddress,
                phoneNumber: companyFormData.companyPhone,
            }

            AuthRestAPI.companyRegistration(payload)
                .then((res) => {
                    dispatch(companyRegisterSuccess(res.data));
                    setCurrent(current + 1);
                }).catch((err) => {
                    if (err.response) {
                        dispatch(companyRegisterFailure(err.response.data));
                        openNotificationWithIcon('error', 'Company register failed', `${err.response.data.message}`, 'topRight');
                    } else {
                        dispatch(companyRegisterFailure(err.message));
                        openNotificationWithIcon('error', 'Company register failed', '', 'topRight');
                    }
                })
        }
    };
    const prev = () => {
        setCurrent(current - 1);
    };
    const items = steps.map((item) => ({
        key: item.title,
        title: item.title,
    }));

    const submit = () => {

        const validationResult = validateForm(userFormData, validationRules)

        if (!validationResult.isValid) {
            const err = validationResult.errors
            const newErrors = {};
            Object.keys(err).forEach((value) => {
                newErrors[value] = err[value];
            })
            setErrors(newErrors);

            openNotificationWithIcon('error', "Validation", Object.values(err)[0], 'bottomLeft')

        } else {
            AuthRestAPI.companyAdminRegistration(userFormData)
                .then((res) => {
                    openNotificationWithIcon('success', `${res.message}`, '', 'bottomLeft');
                    //navigate("/login")
                    navigate(`/process-end?email=${AESEncryption(userFormData.email)}`)
                }).catch((err) => {
                    if (err.response) {
                        openNotificationWithIcon('error', 'Sign up failed', `${err.response.data}`, 'bottomLeft');
                    } else {
                        openNotificationWithIcon('error', 'Sign up failed', `${err.message}`, 'bottomLeft');
                    }
                })
        }
    }

    return (
        <div>
            <Row>
                <Col>
                    <h1 style={TEXT.heading1}>Sign Up </h1>
                    <br/>
                    <Text type='secondary'>
                        Begin your OCTOPLEX journey! To kickstart your journey towards streamlined board meetings and optimized workflows, please enter your details below. <br />Let OCTOPLEX empower your organization with seamless setup and enhanced productivity.
                    </Text>
                    <br/>
                    <br/>
                </Col>
            </Row>
            <Row>
                <Col xs={{
                    span: 20,
                }}
                    md={{
                        span: 18,
                    }}
                    lg={{
                        span: 16,
                    }}>
                    <div >{steps[current].content}</div>
                    <div
                        style={{
                            marginTop: 8,
                        }}
                    >
                        {current < steps.length - 1 && (
                            <Button style={BUTTON.primary} type="primary" onClick={() => next()}>
                                Next
                            </Button>
                        )}
                        {current === steps.length - 1 && (
                            <Button style={BUTTON.primary} type="primary" onClick={() => submit()}>
                                Register
                            </Button>
                        )}
                    </div>
                </Col>
            </Row>
            <Divider />
            Already have an Account ?<Link to='/login'> <Button type='link'>Login</Button></Link>
            <Row>
                {contextHolder}
            </Row>
        </div>
    )
}